import GoogleTagDataLayer from "app/components/GoogleTagDataLayer/GoogleTagDataLayer";
import { MarketsHelper } from "app/helpers/marketsHelper";
import {
  buildEventNavigationUrl,
  storeCurrentRouteAsPrevious,
} from "app/helpers/navigationUtils";
import { toUrlFriendlyName } from "app/screens/EventsScreen/screens/CompetitionScreenWrapper/nameHelper";
import type { EventType } from "app/types/eventType";
import React from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { EventNameSection } from "../../../../components/EventNameSection/EventNameSection";
import { EventNameSectionTop } from "../../../../components/EventNameSectionTop/EventNameSectionTop";
import PopularEventCellMarkets from "../PopularEventCellMarkets/PopularEventCellMarkets";
import PopularEventCellMarketsLoading from "../PopularEventCellMarketsLoading/PopularEventCellMarketsLoading";
import PopularEventCellMarketsTotal from "../PopularEventCellMarketsTotal/PopularEventCellMarketsTotal";
type Props = {
  data: EventType;
  toggleAddRemoveToFavorites: (...args: Array<any>) => any;
  isEventInExtraTime: any;
  scoreFullTime: any;
  isBeforeExtraTime: any;
  isFavourite: any;
  side: any;
  eventIncidents: any;
  DangerZoneTextOnly: any;
  toggleAlternativeLines: (...args: Array<any>) => any;
  isEventLoading: boolean;
  numberOfMarkets: number;
  noOddsMessage: string;
  updateUnsummarizedMarketsModalEvent: (...args: Array<any>) => any;
  handleChildHover: () => void;
  handleChildLeave: () => void;
};

const PopularEventCellLabel: React.FC<Props> = props => {
  const {
    data,
    toggleAddRemoveToFavorites,
    isEventInExtraTime,
    scoreFullTime,
    isBeforeExtraTime,
    isFavourite,
    side,
    eventIncidents,
    DangerZoneTextOnly,
    toggleAlternativeLines,
    isEventLoading,
    numberOfMarkets,
    noOddsMessage,
    updateUnsummarizedMarketsModalEvent,
    handleChildHover,
    handleChildLeave,
  } = props;

  const isOutright = MarketsHelper.isOutright(null, data.sportType);
  const urlFriendlyName = toUrlFriendlyName(data.name);

  const history = useHistory();
  const onClick = () => {
    storeCurrentRouteAsPrevious();
    const url = buildEventNavigationUrl(data.id, data.name);
    history.push(url);
  };

  if (data != null && data.marketPeriods != null) {
    return (
      <>
        <GoogleTagDataLayer
          googleTagClickId={"popular-event-cell__label"}
          dlvEventName={"DLV-Event-Summary"}
        >
          <div
            className="popular-event-cell__label"
            onClick={() => onClick()}
            onMouseEnter={handleChildHover}
            onMouseLeave={handleChildLeave}
          >
            <div className="popular-event-cell__label__content">
              <EventNameSectionTop
                data={data}
                toggleAddRemoveToFavorites={toggleAddRemoveToFavorites}
                isEventInExtraTime={isEventInExtraTime}
                scoreFullTime={scoreFullTime}
                isBeforeExtraTime={isBeforeExtraTime}
                isFavourite={isFavourite}
              />
              {isOutright ? (
                <span className="popular-event-cell__label__competition">
                  {data.name}
                </span>
              ) : (
                <EventNameSection
                  side={side}
                  data={data}
                  eventIncidents={eventIncidents}
                  DangerZoneTextOnly={DangerZoneTextOnly}
                />
              )}
            </div>
            {/* end - popular-event-cell__label__content */}
          </div>
        </GoogleTagDataLayer>
        {isEventLoading ? (
          <PopularEventCellMarketsLoading />
        ) : (
          <React.Fragment>
            {!isOutright && (
              <PopularEventCellMarkets
                data={data}
                toggleAlternativeLines={toggleAlternativeLines}
                noOddsMessage={noOddsMessage}
                isOutright={isOutright}
              />
            )}
          </React.Fragment>
        )}
        {numberOfMarkets > 0 && (
          <PopularEventCellMarketsTotal
            data={data}
            numberOfMarkets={numberOfMarkets}
            toggleAlternativeLines={toggleAlternativeLines}
          />
        )}
      </>
    );
  }
  return (
    <>
      <div className="popular-event-cell__label">
        <div className="popular-event-cell__label__content">
          <EventNameSectionTop
            data={data}
            toggleAddRemoveToFavorites={toggleAddRemoveToFavorites}
            isEventInExtraTime={isEventInExtraTime}
            scoreFullTime={scoreFullTime}
            isBeforeExtraTime={isBeforeExtraTime}
            isFavourite={isFavourite}
          />
          {isOutright ? (
            <span className="popular-event-cell__label__competition">
              {data.name}
            </span>
          ) : (
            <EventNameSection
              side={side}
              data={data}
              eventIncidents={eventIncidents}
              DangerZoneTextOnly={DangerZoneTextOnly}
            />
          )}
        </div>
        {/* end - popular-event-cell__label__content */}
      </div>
      {isEventLoading ? (
        <PopularEventCellMarketsLoading />
      ) : (
        <React.Fragment>
          <PopularEventCellMarkets
            data={data}
            toggleAlternativeLines={toggleAlternativeLines}
            noOddsMessage={noOddsMessage}
            isOutright={isOutright}
          />
        </React.Fragment>
      )}
      {numberOfMarkets > 0 && (
        <PopularEventCellMarketsTotal
          data={data}
          numberOfMarkets={numberOfMarkets}
          toggleAlternativeLines={toggleAlternativeLines}
        />
      )}
    </>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    updateUnsummarizedMarketsModalEvent: (event: EventType) => {
      dispatch.competitionListModel.updateUnsummarizedMarketsModalEvent(event);
    },
  };
}

export default connect(null, mapDispatchToProps)(PopularEventCellLabel);
